import { Box, Typography } from '@mui/material'
import { useTranslation } from 'react-i18next'
import { useSharedStyles } from '@/pages/Settings/useSharedStyles'
import { EpgArrowLeft, RawLink } from '@/shared/ui'
import { DataCheckbox } from '@/components/settings/components/DataCheckbox'
import { useAppStore } from '@/shared/store'
import {
    homePagePath,
    termsIframeHeight,
    termsIframeWidth,
} from '@/shared/constants'

const TermsAndConditions = () => {
    const { t: translate } = useTranslation()
    const { termsAndConditions, setTermsAndConditions } = useAppStore()
    const { isTermsAccepted } = termsAndConditions
    const { url } = termsAndConditions ?? {}
    const { titleContainer, sectionStyle, container } = useSharedStyles()

    const titleStyle = {
        typography: 'headline3',
        lineHeight: '28px',
        color: 'white',
    }

    const handleTermsAccept = () => {
        setTermsAndConditions({
            ...termsAndConditions,
            isTermsAccepted: !isTermsAccepted,
        })
    }
    const containerStyle = {
        width: '100%',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
    }

    return (
        <Box sx={container}>
            <Box sx={containerStyle}>
                <Box mr="auto" position="relative" top="15px" left="30px">
                    <RawLink to={homePagePath}>
                        <EpgArrowLeft />
                    </RawLink>
                </Box>
                <Box mr="auto">
                    <Typography mt="24px" sx={titleStyle}>
                        {translate('TermsAndConditionsTitle')}
                    </Typography>
                </Box>
            </Box>
            <Box sx={sectionStyle}>
                <Box sx={titleContainer}>
                    <Typography ml="24px" sx={titleStyle}>
                        {translate('info')}
                    </Typography>
                </Box>

                {url && (
                    <>
                        <iframe
                            id="termsAndConditions"
                            src={url}
                            title="termsAndConditionsFrame"
                            width={termsIframeWidth}
                            height={termsIframeHeight}
                            sandbox="allow-same-origin"
                        />

                        <DataCheckbox
                            fieldName="AcceptPrivacyPolicy"
                            value={isTermsAccepted}
                            onChange={handleTermsAccept}
                        />
                    </>
                )}
            </Box>
        </Box>
    )
}

export { TermsAndConditions }
